import type { MfaMethod } from "@privy-io/react-auth"

// Sorted by display priority when all enrolled or when none enrolled.
export const SUPPORTED_MFA_METHODS: MfaMethod[] = ["totp", "sms"]
